import { render, staticRenderFns } from "./WorkExperienceModal.vue?vue&type=template&id=4b1f8009&scoped=true"
import script from "./WorkExperienceModal.vue?vue&type=script&lang=ts"
export * from "./WorkExperienceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f8009",
  null
  
)

export default component.exports